module.exports = __webpack_public_path__ + "static/mx-4fb7c48ff03d98d3566d691cb6eec67e.svg";